export default {
  title: 'Unsere Dienstleistungen',
  consulting: {
    title: 'Beratung',
    description: 'Professionelle Unterstützung bei Entscheidungen auf dem Immobilienmarkt.',
    more: 'Mehr erfahren',
  },
  ai_valuation: {
    title: 'Bewertung mit KI',
    description: 'Sofortige Immobilienbewertung unter Verwendung von Algorithmen.',
    more: 'Mehr erfahren',
  },
  market_analytics: {
    title: 'Marktanalyse',
    description: 'Regelmäßige Berichte über den Zustand und die Trends des Immobilienmarktes.',
    more: 'Lesen',
  },
  data_security: {
    title: 'Datensicherheit',
    description: 'Moderne Methoden zur Speicherung und Verarbeitung Ihrer Informationen.',
    more: 'Mehr erfahren',
  },
  automation: {
    title: 'Automatisierung',
    description: 'Reduzierung manueller Arbeit durch Prozessautomatisierung.',
    more: 'Anzeigen',
  },
  internet_solutions: {
    title: 'Internetlösungen',
    description: 'Integration mit digitalen Diensten und IoT für Smart Homes.',
    more: 'Erfahren',
  }
}
